import { render, staticRenderFns } from "./createBenefitGroup.vue?vue&type=template&id=c77c112a"
import script from "./createBenefitGroup.vue?vue&type=script&lang=js"
export * from "./createBenefitGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports